(function(){
  'use strict';

  if (window.__ALLPOWERS_REWARDS_HUB_V2__) return;
  window.__ALLPOWERS_REWARDS_HUB_V2__ = true;

  function q(root, sel){ return root ? root.querySelector(sel) : null; }
  function qa(root, sel){ return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }
  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function brandCustomerText(value){
    return String(value == null ? '' : value)
      .replace(/Smile\.io rewards program/gi,'ALLPOWERS Rewards program')
      .replace(/Smile\.io rewards panel/gi,'ALLPOWERS Rewards')
      .replace(/Smile rewards panel/gi,'ALLPOWERS Rewards')
      .replace(/Smile Rewards/gi,'ALLPOWERS Rewards')
      .replace(/Smile\.io/gi,'ALLPOWERS Rewards')
      .replace(/\bSmile\b/gi,'ALLPOWERS Rewards');
  }
  function brandCustomerHtml(value){
    return brandCustomerText(value);
  }
  function brandVisibleCopy(root){
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        var p = node.parentElement;
        if (!p || p.closest('script,style')) return NodeFilter.FILTER_REJECT;
        return /Smile/i.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function(node){ node.nodeValue = brandCustomerText(node.nodeValue); });
  }

  function fmtNumber(n){
    var x = Number(n);
    return Number.isFinite(x) ? x.toLocaleString('en-US') : '';
  }
  function firstDefined(){
    for (var i=0;i<arguments.length;i++) {
      if (arguments[i] !== undefined && arguments[i] !== null && arguments[i] !== '') return arguments[i];
    }
    return null;
  }
  function asArray(value){
    if (Array.isArray(value)) return value;
    if (!value || typeof value !== 'object') return [];
    var keys = ['data','items','results','pointsProducts','points_products','earningRules','earning_rules'];
    for (var i=0;i<keys.length;i++) {
      if (Array.isArray(value[keys[i]])) return value[keys[i]];
    }
    return [];
  }

  function iconSvg(type){
    var common = 'viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"';
    var stroke = 'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"';
    switch(type){
      case 'facebook':
        return '<svg '+common+'><path fill="currentColor" d="M13.6 21v-8h2.8l.4-3h-3.2V8.1c0-.9.3-1.5 1.6-1.5H17V4a23 23 0 0 0-2.5-.1c-2.5 0-4.2 1.5-4.2 4.3V10H7.5v3h2.8v8h3.3Z"/></svg>';
      case 'instagram':
        return '<svg '+common+'><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5" '+stroke+'/><circle cx="12" cy="12" r="4.1" '+stroke+'/><circle cx="17.4" cy="6.8" r="1" fill="currentColor"/></svg>';
      case 'tiktok':
        return '<svg '+common+'><path d="M14.2 4.2v10.2a4.5 4.5 0 1 1-3.8-4.5" '+stroke+'/><path d="M14.2 4.2c.8 2.4 2.2 3.7 4.6 4.1" '+stroke+'/></svg>';
      case 'youtube':
        return '<svg '+common+'><path d="M21 8.2a3 3 0 0 0-2.1-2.1C17.1 5.6 12 5.6 12 5.6s-5.1 0-6.9.5A3 3 0 0 0 3 8.2 31 31 0 0 0 2.6 12 31 31 0 0 0 3 15.8a3 3 0 0 0 2.1 2.1c1.8.5 6.9.5 6.9.5s5.1 0 6.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .4-3.8 31 31 0 0 0-.4-3.8Z" '+stroke+'/><path d="m10 9.4 5 2.6-5 2.6V9.4Z" fill="currentColor"/></svg>';
      case 'birthday':
        return '<svg '+common+'><path d="M4 10h16v10H4z" '+stroke+'/><path d="M3 10h18M12 10v10M7.5 10c-2.4 0-3.6-1.2-3.6-2.5S5 5 6.5 5C9 5 12 10 12 10s3-5 5.5-5C19 5 20 6.1 20 7.5S18.9 10 16.5 10" '+stroke+'/><path d="M12 4V2" '+stroke+'/></svg>';
      case 'account':
        return '<svg '+common+'><circle cx="12" cy="8" r="3.2" '+stroke+'/><path d="M5 20c.6-4 3-6 7-6s6.4 2 7 6" '+stroke+'/><path d="M18 4v4M16 6h4" '+stroke+'/></svg>';
      case 'cart':
        return '<svg '+common+'><path d="M3 4h2l2 10h10l2-7H6" '+stroke+'/><circle cx="9" cy="19" r="1.3" fill="currentColor"/><circle cx="17" cy="19" r="1.3" fill="currentColor"/></svg>';
      case 'share':
        return '<svg '+common+'><circle cx="18" cy="5" r="2" '+stroke+'/><circle cx="6" cy="12" r="2" '+stroke+'/><circle cx="18" cy="19" r="2" '+stroke+'/><path d="m7.8 11 8.4-4.8M7.8 13l8.4 4.8" '+stroke+'/></svg>';
      case 'gift':
        return '<svg '+common+'><path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13" '+stroke+'/><path d="M12 7H8.8A2.8 2.8 0 1 1 12 3.2V7Zm0 0h3.2A2.8 2.8 0 1 0 12 3.2V7Z" '+stroke+'/></svg>';
      case 'discount':
        return '<svg '+common+'><path d="M20 13 13 20 4 11V4h7l9 9Z" '+stroke+'/><circle cx="8.2" cy="8.2" r="1.2" fill="currentColor"/></svg>';
      case 'bolt':
        return '<svg '+common+'><path d="m13.5 2-8 11h6l-1 9 8-12h-6l1-8Z" '+stroke+'/></svg>';
      default:
        return '<svg '+common+'><circle cx="12" cy="12" r="9" '+stroke+'/><path d="M12 8v8M8 12h8" '+stroke+'/></svg>';
    }
  }

  function earningIconType(name){
    var s = String(name || '').toLowerCase();
    if (s.indexOf('facebook') >= 0) return 'facebook';
    if (s.indexOf('instagram') >= 0) return 'instagram';
    if (s.indexOf('tiktok') >= 0) return 'tiktok';
    if (s.indexOf('youtube') >= 0) return 'youtube';
    if (s.indexOf('birthday') >= 0 || s.indexOf('birth') >= 0) return 'birthday';
    if (s.indexOf('account') >= 0 || s.indexOf('sign up') >= 0 || s.indexOf('signup') >= 0 || s.indexOf('join') >= 0) return 'account';
    if (s.indexOf('order') >= 0 || s.indexOf('purchase') >= 0 || s.indexOf('shop') >= 0) return 'cart';
    if (s.indexOf('share') >= 0 || s.indexOf('refer') >= 0) return 'share';
    return 'bolt';
  }

  function openSmile(root, type){
    var home = root.dataset.smileHome || '#smile-home';
    var rewards = root.dataset.smileRewards || '#smile-points-activity-rules';
    var referral = root.dataset.smileReferral || '#smile-referral-program-details';
    var hash = type === 'referral' ? referral : (type === 'rewards' ? rewards : home);
    var normalizedHash = String(hash || '').replace(/^#/,'');

    if (normalizedHash) window.location.hash = normalizedHash;

    try {
      if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
        if (typeof window.SmileUI.ready === 'function') {
          Promise.resolve(window.SmileUI.ready()).then(function(){
            try { window.SmileUI.openPanel(); } catch(e){}
          }).catch(function(){});
        } else {
          window.SmileUI.openPanel();
        }
      }
    } catch(e){}
  }

  function bindSmileButtons(root){
    qa(root,'[data-smile-action]').forEach(function(el){
      if (el.dataset.apSmileBound === '1') return;
      el.dataset.apSmileBound = '1';
      el.addEventListener('click', function(e){
        var type = el.dataset.smileAction || 'home';
        var href = el.getAttribute && (el.getAttribute('href') || '');
        if (el.tagName === 'A' && href.indexOf('#smile-') !== 0 && href !== '#') return;
        e.preventDefault();
        openSmile(root, type);
      });
    });
  }

  function bindTabs(root){
    var buttons = qa(root,'[data-rewards-tab]');
    var panels = qa(root,'[data-rewards-panel]');
    buttons.forEach(function(btn){
      if (btn.dataset.apTabBound === '1') return;
      btn.dataset.apTabBound = '1';
      btn.addEventListener('click', function(){
        var tab = btn.dataset.rewardsTab;
        buttons.forEach(function(b){
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true':'false');
        });
        panels.forEach(function(p){
          var active = p.dataset.rewardsPanel === tab;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      });
    });
  }

  function bindSmoothNav(root){
    qa(root,'.ap-rewards__nav a').forEach(function(a){
      if (a.dataset.apNavBound === '1') return;
      a.dataset.apNavBound = '1';
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href');
        if(!id || id.charAt(0)!=='#') return;
        var target = document.querySelector(id);
        if(!target) return;
        e.preventDefault();
        target.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }

  function openRulesModal(root, trigger){
    var modal = q(root,'[data-rules-modal]');
    var dialog = q(root,'[data-rules-dialog]');
    var titleEl = q(root,'[data-rules-modal-title]');
    var rewardEl = q(root,'[data-rules-modal-reward]');
    var bodyEl = q(root,'[data-rules-modal-body]');
    if (!modal || !dialog || !bodyEl) return;

    var card = trigger && trigger.closest ? trigger.closest('.ap-rewards__reward-card') : null;
    var tpl = card ? q(card,'template[data-rules-content]') : null;

    if (titleEl) titleEl.textContent = (trigger && trigger.dataset.rulesTitle) || root.dataset.rulesTitle || 'Rules';
    if (rewardEl) rewardEl.textContent = (trigger && trigger.dataset.rulesReward) || '';
    bodyEl.innerHTML = tpl ? brandCustomerHtml(String(tpl.innerHTML || '').trim()) : '';

    root.__apRulesLastTrigger = trigger || null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('ap-rewards-modal-open');
    window.requestAnimationFrame(function(){
      try { dialog.focus({preventScroll:true}); } catch(e){ try { dialog.focus(); } catch(_e){} }
    });
  }

  function closeRulesModal(root){
    var modal = q(root,'[data-rules-modal]');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('ap-rewards-modal-open');
    var last = root.__apRulesLastTrigger;
    root.__apRulesLastTrigger = null;
    if (last && typeof last.focus === 'function') {
      try { last.focus({preventScroll:true}); } catch(e){ try { last.focus(); } catch(_e){} }
    }
  }

  function bindRulesModal(root){
    if (root.dataset.apRulesBound === '1') return;
    root.dataset.apRulesBound = '1';

    root.addEventListener('click',function(e){
      var target = e.target && e.target.closest ? e.target : null;
      if (!target) return;

      var trigger = target.closest('[data-reward-rules]');
      if (trigger && root.contains(trigger)) {
        e.preventDefault();
        openRulesModal(root, trigger);
        return;
      }

      var closer = target.closest('[data-rules-close]');
      if (closer && root.contains(closer)) {
        e.preventDefault();
        closeRulesModal(root);
      }
    });

    root.addEventListener('keydown',function(e){
      if (e.key === 'Escape') closeRulesModal(root);
    });
  }

  function isSmileSdkReady(){
    return !!(window.Smile && window.Smile.pointsProducts && typeof window.Smile.pointsProducts.get === 'function');
  }

  function waitForSmileSdk(timeoutMs){
    timeoutMs = timeoutMs || 12000;
    if (isSmileSdkReady()) return Promise.resolve(window.Smile);

    return new Promise(function(resolve, reject){
      var done = false;
      var start = Date.now();
      var timer = null;

      function finish(ok){
        if (done) return;
        done = true;
        if (timer) clearInterval(timer);
        document.removeEventListener('smile-js-initialized', onReady);
        document.removeEventListener('smile-js-loaded', onReady);
        if (ok && isSmileSdkReady()) resolve(window.Smile);
        else reject(new Error('Smile.js SDK was not ready before timeout'));
      }
      function onReady(){
        if (isSmileSdkReady()) finish(true);
      }

      document.addEventListener('smile-js-initialized', onReady);
      document.addEventListener('smile-js-loaded', onReady);
      timer = setInterval(function(){
        if (isSmileSdkReady()) return finish(true);
        if (Date.now() - start > timeoutMs) finish(false);
      }, 250);
    });
  }

  function normalizePointsProduct(p){
    if (!p) return {};
    return {
      id: firstDefined(p.id, ''),
      exchangeType: firstDefined(p.exchangeType, p.exchange_type, ''),
      exchangeDescription: firstDefined(p.exchangeDescription, p.exchange_description, ''),
      pointsPrice: firstDefined(p.pointsPrice, p.points_price, null),
      variablePointsStep: firstDefined(p.variablePointsStep, p.variable_points_step, null),
      variablePointsStepRewardValue: firstDefined(p.variablePointsStepRewardValue, p.variable_points_step_reward_value, null),
      variablePointsMin: firstDefined(p.variablePointsMin, p.variable_points_min, null),
      variablePointsMax: firstDefined(p.variablePointsMax, p.variable_points_max, null),
      reward: p.reward || {}
    };
  }

  function normalizeReward(r){
    r = r || {};
    return {
      id: firstDefined(r.id, ''),
      name: firstDefined(r.name, ''),
      description: firstDefined(r.description, ''),
      imageUrl: firstDefined(r.imageUrl, r.image_url, '')
    };
  }

  function classifyProduct(raw){
    var p = normalizePointsProduct(raw);
    var r = normalizeReward(p.reward);
    var s = [r.name, r.description, p.exchangeDescription].filter(Boolean).join(' ').toLowerCase();

    var physicalSignals = [
      'free allpowers','free product','solar panel','power bank','charger','charging cable','extension cable',
      'connector','xt60','5521','sp001','sp002','pb100','p100','cable coupon','car charger','pv connection'
    ];
    for (var i=0;i<physicalSignals.length;i++) {
      if (s.indexOf(physicalSignals[i]) >= 0 && s.indexOf('free shipping') < 0) return 'product';
    }

    // Smile variable points products on Shopify are normally incremental monetary discounts
    // (for example, 100 points = $1 off). Treat them as coupons unless the reward
    // clearly names a physical product above.
    if (String(p.exchangeType || '').toLowerCase() === 'variable') return 'coupon';

    if (/\b[0-9]+\s*%\s*off\b|percentage|order discount|amount off|\$\s*\d+(?:\.\d+)?(?:\s*off)?|free shipping|discount/.test(s)) return 'coupon';
    if (/\bcoupon\b/.test(s) && !/cable|panel|charger|connector|bank|product/.test(s)) return 'coupon';
    return 'product';
  }

  function hasCjk(value){
    return /[\u3400-\u9fff]/.test(String(value || ''));
  }

  function variableRewardSummary(p, pointsLabel){
    p = normalizePointsProduct(p);
    var label = pointsLabel || 'Allpoint';
    var step = Number(p.variablePointsStep);
    var value = Number(p.variablePointsStepRewardValue);
    var max = Number(p.variablePointsMax);
    if (Number.isFinite(step) && step > 0 && Number.isFinite(value) && value > 0) {
      var text = fmtNumber(step) + ' ' + label + ' = $' + fmtNumber(value) + ' OFF';
      if (Number.isFinite(max) && max > 0) text += ' · Up to ' + fmtNumber(max) + ' ' + label;
      return text;
    }
    return '';
  }

  function cleanRewardTitle(raw){
    var p = normalizePointsProduct(raw);
    var r = normalizeReward(p.reward);
    var type = String(p.exchangeType || '').toLowerCase();
    var name = r.name || p.exchangeDescription || 'Reward';
    if (type === 'variable') return 'Flexible Discount';
    name = String(name)
      .replace(/\s+Coupon\s*$/i,'')
      .replace(/^Redeem\s+/i,'')
      .trim();
    if (hasCjk(name)) {
      var pct = name.match(/([0-9]+(?:\.[0-9]+)?)\s*%/);
      if (pct) return pct[1] + '% OFF';
      return 'Member Reward';
    }
    return name;
  }

  function pointsProductLabel(raw, pointsLabel){
    var p = normalizePointsProduct(raw);
    var label = pointsLabel || 'Allpoint';
    if (String(p.exchangeType || '').toLowerCase() === 'fixed' && p.pointsPrice != null) return fmtNumber(p.pointsPrice) + ' ' + label;
    if (String(p.exchangeType || '').toLowerCase() === 'variable') {
      var summary = variableRewardSummary(p, label);
      if (summary) return summary;
      if (p.variablePointsMin != null) return 'From ' + fmtNumber(p.variablePointsMin) + ' ' + label;
      if (p.exchangeDescription && !hasCjk(p.exchangeDescription)) return p.exchangeDescription;
      return 'Flexible ' + label + ' redemption';
    }
    if (p.pointsPrice != null) return fmtNumber(p.pointsPrice) + ' ' + label;
    return (p.exchangeDescription && !hasCjk(p.exchangeDescription)) ? p.exchangeDescription : '';
  }

  function rewardImageMarkup(raw, kind, title){
    var p = normalizePointsProduct(raw);
    var r = normalizeReward(p.reward);
    if (kind === 'coupon') {
      var couponHero = String(p.exchangeType || '').toLowerCase() === 'variable' ? '$ OFF' : (title || 'REWARD');
      return '<div class="ap-rewards__reward-media ap-rewards__reward-media--coupon" data-smile-reward-media>'+
        '<div class="ap-rewards__coupon-ticket"><small>ALLPOWERS REWARDS</small><strong>'+esc(couponHero)+'</strong></div>'+
      '</div>';
    }
    if (r.imageUrl) {
      return '<div class="ap-rewards__reward-media" data-smile-reward-media><img src="'+esc(r.imageUrl)+'" alt="" loading="lazy"></div>';
    }
    return '<div class="ap-rewards__reward-media ap-rewards__reward-media--placeholder" data-smile-reward-media>'+
      iconSvg('gift')+'</div>';
  }

  function defaultRulesHtml(root, kind){
    var tpl = q(root, 'template[data-default-rules="'+kind+'"]');
    return tpl ? String(tpl.innerHTML || '').trim() : '';
  }

  function rewardRulesHtml(root, kind, desc, raw, pointsLabel){
    var html = '';
    var p = normalizePointsProduct(raw || {});
    var note = desc ? brandCustomerText(desc) : '';
    if (String(p.exchangeType || '').toLowerCase() === 'variable') {
      note = variableRewardSummary(p, pointsLabel || 'Allpoint');
    } else if (hasCjk(note)) {
      note = '';
    }
    if (note) html += '<p class="ap-rewards__rules-note">'+esc(note)+'</p>';
    html += defaultRulesHtml(root, kind);
    return html;
  }

  function rewardCard(root, raw, kind, pointsLabel){
    var p = normalizePointsProduct(raw);
    var r = normalizeReward(p.reward);
    var name = cleanRewardTitle(raw);
    var sourceTitle = [r.name, p.exchangeDescription].filter(Boolean).join(' ');
    var rulesLabel = root.dataset.rulesLabel || 'Rules';
    var rulesTitle = root.dataset.rulesTitle || 'Rules';
    var rulesHtml = rewardRulesHtml(root, kind, r.description || '', raw, pointsLabel);

    return '<article class="ap-rewards__reward-card ap-rewards__reward-card--'+kind+'" data-live-reward-card data-reward-kind="'+kind+'" data-reward-search="'+esc(sourceTitle)+'">'+
      rewardImageMarkup(raw, kind, name)+
      '<div class="ap-rewards__reward-body">'+
        '<h3>'+esc(name)+'</h3>'+
        '<button class="ap-rewards__rules-link" type="button" data-reward-rules data-rules-title="'+esc(rulesTitle)+'" data-rules-reward="'+esc(name)+'">'+esc(rulesLabel)+'</button>'+
        '<div class="ap-rewards__reward-points">'+esc(pointsProductLabel(raw, pointsLabel))+'</div>'+
        '<button class="ap-rewards__btn ap-rewards__btn--card" type="button" data-live-smile-open="rewards">Redeem in Rewards</button>'+
        '<template data-rules-content>'+rulesHtml+'</template>'+
      '</div>'+
    '</article>';
  }

  function renderProducts(root, products, pointsLabel){
    var coupons = [];
    var productRewards = [];
    asArray(products).forEach(function(item){
      var kind = classifyProduct(item);
      (kind === 'coupon' ? coupons : productRewards).push(item);
    });

    var liveCoupons = q(root,'[data-live-coupons]');
    var liveProducts = q(root,'[data-live-products]');

    if (liveCoupons) {
      liveCoupons.innerHTML = coupons.map(function(item){ return rewardCard(root,item,'coupon',pointsLabel); }).join('');
      liveCoupons.hidden = coupons.length === 0;
    }
    if (liveProducts) {
      liveProducts.innerHTML = productRewards.map(function(item){ return rewardCard(root,item,'product',pointsLabel); }).join('');
      liveProducts.hidden = productRewards.length === 0;
    }

    qa(root,'[data-live-smile-open]').forEach(function(btn){
      btn.addEventListener('click',function(){ openSmile(root, btn.dataset.liveSmileOpen || 'rewards'); });
    });

    if (productRewards.length && root.dataset.matchShopifyImages === 'true') hydrateShopifyProductImages(root);

    return {couponCount: coupons.length, productCount: productRewards.length};
  }

  function getNumericDeep(obj, paths){
    for (var i=0;i<paths.length;i++) {
      var cur = obj;
      var parts = paths[i].split('.');
      for (var j=0;j<parts.length;j++) {
        if (cur == null) break;
        cur = cur[parts[j]];
      }
      if (cur != null && !isNaN(Number(cur))) return Number(cur);
    }
    return null;
  }

  function earningValue(rule, pointsLabel){
    var rv = firstDefined(rule && rule.rewardValue, rule && rule.reward_value, null) || {};
    var label = pointsLabel || 'Allpoint';
    var fixed = getNumericDeep(rv,['fixed.value','fixed','value','amount','points']);
    var variableValue = getNumericDeep(rv,['variable.value','value']);
    var perAmount = getNumericDeep(rv,['variable.perAmount','variable.per_amount','perAmount','per_amount']);
    var type = String(firstDefined(rv.type, '') || '').toLowerCase();

    if ((type === 'variable' || perAmount != null) && variableValue != null && perAmount != null) {
      var currency = '$';
      return fmtNumber(variableValue) + ' ' + label + ' / ' + currency + fmtNumber(perAmount);
    }
    if (fixed != null) return '+' + fmtNumber(fixed) + ' ' + label;

    var reward = rule && rule.reward ? rule.reward : {};
    var text = [reward.name, reward.description].filter(Boolean).join(' ');
    var m = text.match(/([0-9][0-9,]*)\s*(?:point|allpoint)/i);
    if (m) return '+' + m[1] + ' ' + label;
    return 'Earn ' + label;
  }

  function earningDisplayName(value){
    var raw = String(value || 'Earn points').trim();
    var s = raw.toLowerCase();
    if (/^sign\s*up$|^signup$|create.*account|join.*program/.test(s)) return 'Create an Account';
    if (/birthday/.test(s)) return 'Birthday Reward';
    if (/place.*order|make.*purchase|shop.*earn/.test(s)) return 'Shop & Earn';
    if (/share.*facebook/.test(s)) return 'Share on Facebook';
    if (/like.*facebook/.test(s)) return 'Like on Facebook';
    if (/instagram/.test(s)) return 'Follow on Instagram';
    if (/tiktok/.test(s)) return 'Follow on TikTok';
    if (/youtube/.test(s)) return 'Subscribe on YouTube';
    return hasCjk(raw) ? 'Earn Allpoint' : raw;
  }

  function earningActionLabel(displayName, original){
    var s = String(displayName || '').toLowerCase();
    if (/create an account/.test(s)) return 'Join Now';
    if (/shop & earn/.test(s)) return 'Shop Now';
    if (/facebook|instagram|tiktok|youtube|birthday/.test(s)) return 'Open Rewards';
    var text = String(original || '').trim();
    return (!text || hasCjk(text)) ? 'Open Rewards' : text;
  }

  function renderEarningRules(root, rules, pointsLabel){
    var wrap = q(root,'[data-live-earn]');
    if(!wrap) return 0;
    var arr = asArray(rules);
    var html = arr.map(function(rule){
      var rawName = firstDefined(rule.name, 'Earn points');
      var name = earningDisplayName(rawName);
      var actionText = earningActionLabel(name, firstDefined(rule.actionText, rule.action_text, 'Open Rewards'));
      var actionUrl = firstDefined(rule.actionUrl, rule.action_url, '');
      var imageUrl = firstDefined(rule.imageUrl, rule.image_url, '');
      var icon = imageUrl
        ? '<div class="ap-rewards__earn-icon ap-rewards__earn-icon--image"><img src="'+esc(imageUrl)+'" alt="" loading="lazy"></div>'
        : '<div class="ap-rewards__earn-icon">'+iconSvg(earningIconType(name))+'</div>';
      var action = '';
      if (actionUrl) {
        action = '<a class="ap-rewards__text-button" href="'+esc(actionUrl)+'" target="_blank" rel="noopener">'+esc(actionText || 'Earn Points')+'</a>';
      } else if (actionText) {
        action = '<button class="ap-rewards__text-button" type="button" data-live-smile-open="home">'+esc(actionText || 'Open Rewards')+'</button>';
      }
      return '<article class="ap-rewards__earn-card">'+icon+
        '<div class="ap-rewards__earn-points">'+esc(earningValue(rule, pointsLabel))+'</div>'+ 
        '<h3>'+esc(name)+'</h3>'+ action +'</article>';
    }).join('');

    wrap.innerHTML = html;
    wrap.hidden = !html;
    qa(wrap,'[data-live-smile-open]').forEach(function(btn){
      btn.addEventListener('click',function(){ openSmile(root,'home'); });
    });
    return arr.length;
  }

  function renderMemberBalance(root, Smile){
    var valueEl = q(root,'[data-smile-points]');
    var noteEl = q(root,'[data-smile-member-note]');
    if (!valueEl || !Smile || !Smile.customerPointsWallet || typeof Smile.customerPointsWallet.get !== 'function') return;

    Promise.resolve(Smile.customerPointsWallet.get()).then(function(wallet){
      var balance = null;
      if (typeof wallet === 'number') balance = wallet;
      else if (wallet && typeof wallet === 'object') {
        balance = firstDefined(wallet.pointsBalance, wallet.points_balance, wallet.balance, wallet.points);
      }
      if (balance != null && !isNaN(Number(balance))) {
        valueEl.textContent = fmtNumber(balance);
        if (noteEl) noteEl.textContent = 'Your current ALLPOWERS Rewards balance';
      } else if (noteEl) {
        noteEl.textContent = 'Open Rewards to view your current balance.';
      }
    }).catch(function(){
      if (noteEl) noteEl.textContent = 'Open Rewards to view your current balance.';
    });
  }

  function setFallbackVisible(root, type, visible){
    var el = q(root,'[data-fallback-'+type+']');
    if (el) el.hidden = !visible;
  }

  function setStatus(root, message, state){
    var status = q(root,'[data-sync-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      status.removeAttribute('data-state');
      return;
    }
    status.textContent = brandCustomerText(message);
    status.dataset.state = state || 'info';
    status.hidden = false;
  }

  function normalizeSearchQuery(value){
    return String(value || '')
      .replace(/\bFree\b/ig,' ')
      .replace(/\bCoupon\b/ig,' ')
      .replace(/\bALLPOWERS\b/ig,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function tokenSet(value){
    var stop = {'the':1,'and':1,'with':1,'for':1,'to':1,'a':1,'an':1,'solar':0};
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g,' ').split(/\s+/).filter(function(t){ return t.length > 1 && !stop[t]; });
  }

  function scoreProduct(query, title){
    var a = tokenSet(query), b = tokenSet(title);
    if (!a.length || !b.length) return 0;
    var bset = {};
    b.forEach(function(t){ bset[t]=1; });
    var score = 0;
    a.forEach(function(t){ if (bset[t]) score += /\d/.test(t) ? 3 : 1; });
    return score;
  }

  async function findShopifyProduct(query){
    query = normalizeSearchQuery(query);
    if (!query || typeof fetch !== 'function') return null;
    try {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=show';
      var res = await fetch(url, {headers:{'Accept':'application/json'}, credentials:'same-origin'});
      if (!res.ok) return null;
      var data = await res.json();
      var products = data && data.resources && data.resources.results && data.resources.results.products;
      if (!Array.isArray(products) || !products.length) return null;
      var best = products[0], bestScore = -1;
      products.forEach(function(p){
        var s = scoreProduct(query, p.title || '');
        if (s > bestScore) { best = p; bestScore = s; }
      });
      return bestScore >= 2 ? best : null;
    } catch(e) { return null; }
  }

  function productImageUrl(product){
    if (!product) return '';
    return firstDefined(
      product.featured_image && product.featured_image.url,
      product.featured_image && product.featured_image.src,
      product.image,
      product.image_url,
      ''
    ) || '';
  }

  function hydrateShopifyProductImages(root){
    qa(root,'[data-live-reward-card][data-reward-kind="product"]').forEach(function(card){
      if (card.dataset.apShopifyMatch === '1') return;
      card.dataset.apShopifyMatch = '1';
      var query = card.dataset.rewardSearch || '';
      findShopifyProduct(query).then(function(product){
        if (!product) return;
        var src = productImageUrl(product);
        var media = q(card,'[data-smile-reward-media]');
        if (src && media) {
          media.classList.remove('ap-rewards__reward-media--placeholder');
          media.innerHTML = '<img src="'+esc(src)+'" alt="'+esc(product.title || '')+'" loading="lazy">';
        }
      });
    });
  }

  async function loadFromSmileSdk(root){
    if (root.dataset.smileSdk !== 'true') {
      setFallbackVisible(root,'coupons',true);
      setFallbackVisible(root,'products',true);
      setFallbackVisible(root,'earn',true);
      return;
    }

    setStatus(root, brandCustomerText(root.dataset.loadingText || 'Loading your ALLPOWERS rewards…'), 'loading');

    try {
      var Smile = await waitForSmileSdk(15000);
      var results = await Promise.allSettled([
        Smile.pointsProducts && typeof Smile.pointsProducts.get === 'function' ? Smile.pointsProducts.get() : Promise.resolve([]),
        Smile.earningRules && typeof Smile.earningRules.get === 'function' ? Smile.earningRules.get() : Promise.resolve([])
      ]);

      var products = results[0].status === 'fulfilled' ? results[0].value : [];
      var rules = results[1].status === 'fulfilled' ? results[1].value : [];
      var pointsLabel = root.dataset.pointsLabel || 'Allpoint';
      var counts = renderProducts(root, products, pointsLabel);
      var earnCount = renderEarningRules(root, rules, pointsLabel);

      if (root.dataset.hideFallback === 'true') {
        setFallbackVisible(root,'coupons', counts.couponCount === 0);
        setFallbackVisible(root,'products', counts.productCount === 0);
        setFallbackVisible(root,'earn', earnCount === 0);
      } else {
        setFallbackVisible(root,'coupons',true);
        setFallbackVisible(root,'products',true);
        setFallbackVisible(root,'earn',true);
      }

      renderMemberBalance(root, Smile);
      brandVisibleCopy(root);

      if (counts.couponCount || counts.productCount || earnCount) {
        setStatus(root, '', 'success');
        root.classList.add('ap-rewards--smile-live');
      } else {
        setStatus(root, 'No active rewards are available right now. Please check back soon.', 'info');
      }
    } catch(err) {
      setFallbackVisible(root,'coupons',true);
      setFallbackVisible(root,'products',true);
      setFallbackVisible(root,'earn',true);
      setStatus(root, 'Rewards are temporarily unavailable. Please try again later.', 'error');
      if (window.console) console.warn('[ALLPOWERS Rewards] Smile.js load failed:', err);
    }
  }

  function init(root){
    if(root.dataset.apRewardsInit === '1') return;
    root.dataset.apRewardsInit = '1';
    bindTabs(root);
    bindSmileButtons(root);
    bindSmoothNav(root);
    bindRulesModal(root);
    brandVisibleCopy(root);
    loadFromSmileSdk(root);
  }

  function boot(){ qa(document,'[data-ap-rewards]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  document.addEventListener('shopify:section:load',function(e){
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ap-rewards]') : null;
    if(root) init(root);
  });
})();
